import { useModuleBEM } from "@b2bportal/core-themes";
import { FlightDetailsSegment } from "@tenant/flights";
import { useRebookFlightSegment } from "@tenant/flights-rebook";
import { RadioItem } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./RebookFlightSegment.module.scss";
import type { RebookFlightSegmentProps } from "./types";
import { CoreFlightsRebookComponent } from "~core-flights-rebook/components/rebook-component";
import { useFlightsRebookStyles } from "~core-flights-rebook/styles";

const COMPONENT_KEY = CoreFlightsRebookComponent.RebookFlightSegment;

export const RebookFlightSegment = (props: RebookFlightSegmentProps) => {
  const { className, children } = props;
  const styles = useFlightsRebookStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context } = useRebookFlightSegment(props);
  const { slice, segment, segmentId, disabled, selected } = context;

  return (
    <RadioItem
      key={segmentId}
      id={segmentId}
      value={segmentId}
      className={clsx(block, className)}
      selected={selected}
      disabled={context.disabled}
      classes={{ label: cn("radio-label") }}
    >
      <FlightDetailsSegment
        className={cn("segment", { disabled, selected })}
        segment={segment}
        flightSlice={slice}
      />
      {children}
    </RadioItem>
  );
};
